import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { status } from 'constants/general';
import campaignsStrings from 'modules/campaigns/strings';
import CampaignsFilter from 'modules/campaigns/components/CampaignsFilter';
import CampaignsList from 'modules/campaigns/components/CampaignsList';
import Loader from 'modules/common/components/Loader';
import Pagination from 'modules/common/components/Pagination';

import {
  CampaignsWrapper,
  LoaderWrapper,
  NoResultsWrapper,
  NoResultsText,
  PaginationWrapper,
} from './CampaignsComponent.style';

const CampaignsComponent = ({
  searchQuery,
  selectedPageFilter,
  isActionPopupOpen,
  isActionPopupLoading,
  actionPopupStatus,
  formatCampaignDate,
  handleEditCampaignBtnClick,
  handleAddAdvertBtnClick,
  handleViewAdvertsBtnClick,
  handleSearchBarInputChange,
  handleOrderPaginationClick,
  handleActionBtnClick,
  handleActionPopupConfirmBtnClick,
  handleActionPopupDismissBtnClick,
}) => {
  const { campaignsList } = useSelector(state => ({
    campaignsList: state.campaigns.campaignsList,
  }));

  const totalResultsCount = campaignsList?.details?.totalCount;
  const numberOfPages = (totalResultsCount && Math.ceil(totalResultsCount / 10)) || 1;
  const campaignsListArr = campaignsList?.details?.results;

  const renderCampaignsList = () => {
    if (campaignsList.status === status.SHOULD_CALL_API || campaignsList.status === status.FETCHING)
      return (
        <LoaderWrapper>
          <Loader />
        </LoaderWrapper>
      );

    if (campaignsList.status === status.SUCCESS && campaignsListArr?.length > 0)
      return (
        <>
          <CampaignsList
            campaignsListArr={campaignsListArr}
            isActionPopupOpen={isActionPopupOpen}
            isActionPopupLoading={isActionPopupLoading}
            actionPopupStatus={actionPopupStatus}
            formatCampaignDate={formatCampaignDate}
            handleEditCampaignBtnClick={handleEditCampaignBtnClick}
            handleAddAdvertBtnClick={handleAddAdvertBtnClick}
            handleViewAdvertsBtnClick={handleViewAdvertsBtnClick}
            handleActionBtnClick={handleActionBtnClick}
            handleActionPopupConfirmBtnClick={handleActionPopupConfirmBtnClick}
            handleActionPopupDismissBtnClick={handleActionPopupDismissBtnClick}
          />
          {numberOfPages > 1 && (
            <PaginationWrapper>
              <Pagination
                currentPage={selectedPageFilter}
                totalCount={numberOfPages}
                handleOrderPaginationClick={handleOrderPaginationClick}
              />
            </PaginationWrapper>
          )}
        </>
      );

    return (
      <NoResultsWrapper>
        <NoResultsText>{campaignsStrings.campaignsList.campaignsGridNoResultsFound}</NoResultsText>
      </NoResultsWrapper>
    );
  };

  return (
    <CampaignsWrapper>
      <CampaignsFilter
        searchQuery={searchQuery}
        handleSearchBarInputChange={handleSearchBarInputChange}
      />
      {renderCampaignsList()}
    </CampaignsWrapper>
  );
};

CampaignsComponent.propTypes = {
  searchQuery: PropTypes.string.isRequired,
  selectedPageFilter: PropTypes.number.isRequired,
  isActionPopupOpen: PropTypes.bool.isRequired,
  isActionPopupLoading: PropTypes.bool.isRequired,
  actionPopupStatus: PropTypes.number.isRequired,
  formatCampaignDate: PropTypes.func.isRequired,
  handleEditCampaignBtnClick: PropTypes.func.isRequired,
  handleAddAdvertBtnClick: PropTypes.func.isRequired,
  handleViewAdvertsBtnClick: PropTypes.func.isRequired,
  handleSearchBarInputChange: PropTypes.func.isRequired,
  handleOrderPaginationClick: PropTypes.func.isRequired,
  handleActionBtnClick: PropTypes.func.isRequired,
  handleActionPopupConfirmBtnClick: PropTypes.func.isRequired,
  handleActionPopupDismissBtnClick: PropTypes.func.isRequired,
};

export default CampaignsComponent;
